import ProductVariantModel from '../models/ProductVartiant';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const PRODUCT_VARIANT_URL = `${API_URL}/api/products-variants/`;

export function listProductVariants(): Promise<{
  data: ProductVariantModel[];
}> {
  return axios.get(PRODUCT_VARIANT_URL);
}
